import { render } from "./HeaderVie.vue?vue&type=template&id=6a9cffd1&scoped=true"
import script from "./HeaderVie.vue?vue&type=script&lang=js"
export * from "./HeaderVie.vue?vue&type=script&lang=js"

import "./HeaderVie.vue?vue&type=style&index=0&id=6a9cffd1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9cffd1"]])

export default __exports__